import { Box, Divider, Paper, Stack, Typography } from "@mui/material";
import { isArray } from "lodash";
import { useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import RelationSection from "./RelationSection";
import TrackingSection from "./TrackingSection";

export default function Layout() {
    const { kpi } = useOutletContext();

    const trackings = kpi?.data?.data?.trackings ?? [];
    const relations = kpi?.data?.data?.relations ?? [];

    return (
        <Stack spacing={2}>
            <RelationSection relations={relations} kpiId={kpi?.data?.data?.id} />
            <TrackingSection trackings={trackings} kpiId={kpi?.data?.data?.id} />
        </Stack>
    );
}
